/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lpName: NonNullable<unknown> }} Coinvestments_Dataroom_Togglecolumn3Inputs */

const en_coinvestments_dataroom_togglecolumn3 = /** @type {(inputs: Coinvestments_Dataroom_Togglecolumn3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toggle all access for ${i?.lpName}`)
};

/**
* | output |
* | --- |
* | "Toggle all access for {lpName}" |
*
* @param {Coinvestments_Dataroom_Togglecolumn3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_togglecolumn3 = /** @type {((inputs: Coinvestments_Dataroom_Togglecolumn3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Togglecolumn3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_togglecolumn3(inputs)
});
export { coinvestments_dataroom_togglecolumn3 as "coInvestments_dataRoom_toggleColumn" }